var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-header-index-wide"},[_c('s-breadcrumb')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }